export const APP_ACCOUNT = {
  globalAccountRegister:            'https://conta-dev.plugante.com/register-user',
  globalAccountForgotPassword:      'https://conta-dev.plugante.com/conta/password/forgot',
  globalAccountUser:                'https://conta-dev.plugante.com/conta',
  globalAccountAddress:             'https://conta-dev.plugante.com/conta/address',
  globalAccountPhone:               'https://conta-dev.plugante.com/conta/form/cellphone',
  globalAccountProfile:             'https://conta-dev.plugante.com/conta/profiles/public/details',
  globalAccountCreditCard:          'https://conta-dev.plugante.com/conta/payments/cards',
};


export const APP_SITES = {
  noitadaSite:                      'https://dev.noitada.net',

  noitadaAppLink:                   'https://dev.noitada.app',
};


export const NOITADA_TERMS = {
  licencesLink:                     'https://dev.noitada.net/terms-policy/noitada-license',
  privacityPolicyLink:              'https://dev.noitada.net/terms-policy/noitada-privacity',
  termsUseLink:                     'https://dev.noitada.net/terms-policy/noitada-use',
};



const Vars = {
  ...APP_ACCOUNT,
  ...APP_SITES,
  ...NOITADA_TERMS,
};



export default Vars;
